import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getEnrollmentStatus } from "@/shared/api/payment";
import { useEffect } from "react";

export const useEnrollmentStatus = (enrollmentId: string | null) => {
  const queryClient = useQueryClient();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["enrollment-status", enrollmentId],
    queryFn: () => {
      if (!enrollmentId) throw new Error("Enrollment ID is required");
      return getEnrollmentStatus(enrollmentId);
    },
    enabled: !!enrollmentId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;

      const isFinal =
        status === "succeeded" ||
        status === "cancelled" ||
        status === "refunding" ||
        status === "failed";

      return isFinal ? false : 3000;
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data?.status === "succeeded") {
      queryClient.invalidateQueries({ queryKey: ["saved-payment-methods"] });
    }
  }, [data?.status, queryClient]);

  return { status: data?.status, isLoading, isError };
};
